export default __webpack_public_path__ + "static/media/clock-in.b4ed50a5.png";